import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Helper } from './Helper';


export class BaseService {
  private http: HttpClient;

  constructor(http: any) {
    this.http = http;
  }

  get token()
  {
    return localStorage.getItem("jwt");;
  }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      //console.error(error);
      return of(result as T);
    };
  }

  public GetValue<T>(param: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<T>(Helper.baseApiUrl + param, httpOptions).pipe(
      catchError(this.handleError<T>("GetValue"))
    );
  }
  public GetFile(param: string): Observable<Blob> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token
      })
    };
    return this.http.get(Helper.baseApiUrl + param, {
      headers: httpOptions.headers,
      responseType: 'blob'
    });
  }

  public ExternalGetValue<T>(apiUrl: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<T>(apiUrl, httpOptions).pipe(
      catchError(this.handleError<T>("GetValue"))
    );
  }

  public PostValue(param: string, obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json'
      })
    };
    return this.http.post(Helper.baseApiUrl + param, obj, httpOptions).pipe(
      catchError(this.handleError("PostValue", obj))
    );
  }

  public PostValueSemTratamento(param: string, obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(Helper.baseApiUrl + param, obj, httpOptions);
  }

  public PutValue(param: string, obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json'
      })
    };
    return this.http.put(Helper.baseApiUrl + param, obj, httpOptions).pipe(
      catchError(this.handleError("PutValue", obj))
    );
  }

  public UploadFile(param: string, obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
      })
    };
    const uploadReq = new HttpRequest('POST', Helper.baseApiUrl + 'assets/' + param, obj, {
      headers: httpOptions.headers, reportProgress: true
    });
    return this.http.request(uploadReq).pipe(
      catchError(this.handleError("UploadFile", obj))
    );
  }

  public DeleteValue<T>(param: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json'
      })
    };
    return this.http.delete<T>(Helper.baseApiUrl + param, httpOptions).pipe(
      catchError(this.handleError<T>("DeleteValue"))
    );
  }

  public DownloadFile(param: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
        'Content-Type': 'application/json',
      }),
    };
    return this.http.post(Helper.baseApiUrl + param, httpOptions, { responseType: 'blob' }).pipe(
      catchError(this.handleError("DownloadFile"))
    );
  }

  public ExternalPost(param: string, obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post(param, obj, httpOptions).pipe(
      catchError(this.handleError("ExternalPost", obj))
    );
  }



  public CdnUploadFile(param: string, obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + this.token,
      })
    };
    const uploadReq = new HttpRequest('POST',Helper.baseApiUrl + param, obj, {
      headers: httpOptions.headers, reportProgress: true
    });
    return this.http.request(uploadReq).pipe(
      catchError(this.handleError("UploadFile", obj))
    );
  }



}
